module.exports = __webpack_public_path__ + "static/media/logo.389c23e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo.png
// module id = 1090
// module chunks = 3